(function () {
  'use strict';

  let angular = window.angular;

  PublicRouter.$inject = ['$stateProvider'];

  angular.module('app').config(PublicRouter);

  function PublicRouter($stateProvider) {
    $stateProvider
      .state('member', {
        url: '/member?style&access_token&user_id&embedded',
        redirectTo: 'member.home',
        authenticated: true,
        component: 'memberComponent',
        params: {
          style: { type: 'string', inherit: true },
          access_token: { type: 'string', inherit: true },
          user_id: { type: 'string', inherit: true },
          embedded: { type: 'string', inherit: true },
        },
        resolve: {
          user: [
            'RouterService',
            'UserService',
            'AppUtils',
            '$rootScope',
            function (RouterService, UserService, utils, $root) {
              return UserService.getCurrent()
                .then((current) => {
                  RouterService.storeId(current.id, 'Principal');
                  return RouterService.getPrincipal(current, ['container', 'permission', 'views']);
                })
                .then((user) => {
                  user.image = UserService.getUserImageUrl(user);
                  user.views = utils.arrayToObject(user.views, 'module');
                  user.isMaster = user.permission?.master;
                  $root.isMaster = user.permission?.master;
                  $root.user = user;

                  if (user.mustChangePassword) {
                    const redirectError = new Error('Password change required');
                    redirectError.redirectTo = 'forcePasswordChange';
                    throw redirectError;
                  }

                  return user;
                })
                .catch((err) => {
                  if (err && err.redirectTo) {
                    throw err;
                  }
                  console.log(err);
                  throw utils.getHTTPError(err, { redirectTo: 'public.login' });
                });
            },
          ],
          isMaster: [
            'user',
            function (user) {
              return user.permission?.master;
            },
          ],
          isAdmin: () => false,
          organization: [
            'user',
            'RouterService',
            '$rootScope',
            function (user, RouterService, $root) {
              return RouterService.getCustomer(user).then((organization) => {
                $root.customerId = organization.id;
                $root.customer = organization;
                if (organization.id === '5c8c7820b8bee2001062844d') {
                  $root.systemMessage = {
                    level: 'danger',
                    show: true,
                    text: `Su licencia expirará la proxima semana. Por favor contacte a su administrador de contrato para renovarla.`,
                    allowClose: false,
                  };
                }
                return organization;
              });
            },
          ],
          customer: [
            'organization',
            '$q',
            function (organization, $q) {
              return $q.resolve(organization);
            },
          ],
          managerCount: [
            'user',
            'RouterService',
            (user, RouterService) => {
              return RouterService.getManagersCount(user);
            },
          ],
          projects: [
            'RouterService',
            'user',
            'navbarService',
            'RESTRICTED_USER_PROJECTS',
            function (RouterService, user, navbarService, RESTRICTED_USER_PROJECTS) {
              return RouterService.getProjects({
                customerId: user.customerId,
              }).then((projects) => {
                const allowedProjectId = RESTRICTED_USER_PROJECTS[String(user.id)];
                if (allowedProjectId) {
                  projects = projects.filter((project) => String(project.id) === allowedProjectId);
                }
                navbarService.setProjects(projects);
                return projects;
              });
            },
          ],
          yoloClasses: [
            'RouterService',
            '$rootScope',
            (RouterService, $rootScope) => {
              return RouterService.getYoloClasses().then((classes) => {
                $rootScope.yoloClasses = classes;
                return classes;
              });
            },
          ],
        },
        ncyBreadcrumb: {
          label: '<i class="fas fa-home"></i> Home',
        },
      })
      .state('forcePasswordChange', {
        url: '/password-change',
        authenticated: true,
        component: 'forcePasswordChangePage',
      })
      .state('member.home', {
        url: '/home',
        authenticated: true,
        component: 'customerProjects',
        ncyBreadcrumb: { skip: true },
        resolve: {
          dependencies: [
            '$ocLazyLoad',
            '$rootScope',
            function ($ocLazyLoad, $root) {
              const style = $root.darkMode ? 'dark' : 'light';
              return $ocLazyLoad.load([
                window.assetsPath + '/js/vendors/editors/simplemde.min.js',
                window.assetsPath + `/css/editors-${style}.css`,
              ]);
            },
          ],
        },
      })
      .state('member.dataDisplay', {
        url: '/data-display/:projectId/:assetId/:sensorId?:dataId&:zoneFilter',
        component: 'monitoringDataDisplay',
        authenticated: true,
        ncyBreadcrumb: {
          label: 'Data Display',
        },
        resolve: {
          project: [
            'RouterService',
            'Manager',
            '$transition$',
            'navbarService',
            'AppUtils',
            'user',
            'RESTRICTED_USER_PROJECTS',
            function (RouterService, Manager, $transition$, navbarService, utils, user, RESTRICTED_USER_PROJECTS) {
              let params = $transition$.params();
              const allowedProjectId = RESTRICTED_USER_PROJECTS[String(user.id)];
              if (allowedProjectId && String(params.projectId) !== allowedProjectId) {
                const error = new Error('Project access denied');
                error.redirectTo = 'member.home';
                throw error;
              }
              let current = Manager.getCachedCurrent();
              RouterService.storeId(params.projectId, 'Customer$CurrentProject');
              return RouterService.getProject({
                customerId: current.customerId,
                projectId: params.projectId,
              })
                .then((project) => {
                  navbarService.setProject(project);
                  return project;
                })
                .catch((err) => {
                  throw utils.getHTTPError(err, {
                    redirectTo: 'member.home',
                    params: { customerId: current.customerId },
                  });
                });
            },
          ],
        },
      });
  }
})();
